import { connect } from 'react-redux'

import { doNavigateToTicket } from 'actions/navigation'
import {
  selectRecentTickets,
  selectIsLoading,
  selectIsShowingAll,
  selectHasLoadedAll,
  selectShouldReload,
  doLoadRecentTickets,
  doLoadAllRecentTickets,
  doShowAllTickets,
  doHideAllTickets,
} from 'ducks/inAppCards/recentConversations'
import { selectPrefersExpandedReplyHeader } from 'selectors/app'
import {
  selectCurrentCustomerId,
  selectCurrentTicketId,
} from 'selectors/tickets'

import View from './view'

const select = state => {
  // perf: avoid using ownProps
  const customerId = selectCurrentCustomerId(state)

  return {
    customerId,
    currentTicketId: selectCurrentTicketId(state),
    tickets: selectRecentTickets(state, customerId),
    isLoading: selectIsLoading(state, customerId),
    isShowingAll: selectIsShowingAll(state, customerId),
    hasLoadedAll: selectHasLoadedAll(state, customerId),
    prefersExpandedReplyHeader: selectPrefersExpandedReplyHeader(state),
    reload: selectShouldReload(state, customerId),
  }
}

const perform = dispatch => ({
  onUpdate: (customerId, options) =>
    dispatch(doLoadRecentTickets(customerId, options)),
  onShowAllClick: customerId => {
    dispatch(doLoadAllRecentTickets(customerId))
    dispatch(doShowAllTickets(customerId))
  },
  onHideAllClick: customerId => dispatch(doHideAllTickets(customerId)),
  doNavigateToTicket: ticketId => dispatch(doNavigateToTicket(ticketId)),
})

export default connect(select, perform)(View)
